<header class="stellantis-header">
  <div class="row">
    <div class="col" *ngIf="!isLogged"></div>
    <div class="col" *ngIf="isLogged">
      <ul class="navigation">
        <li><a [routerLink]="['/home']">Home</a></li>
        <li><a [routerLink]="['/vehicles']">Vehicles</a></li>
        <li><a [routerLink]="['/products']">Products</a></li>
        <li><a [routerLink]="['/solutions']">Solutions</a></li>
      </ul>
    </div>
    <div class="col logo">
      <a [routerLink]="['/']">
        <img src="img/logo_stellantis.svg" alt="Logo" class="header-logo" />
      </a>
    </div>
    <div class="col user-panel-container">
      <div
        class="user-panel"
        *ngIf="isLogged"
        (mouseenter)="showPanel = true"
        (mouseleave)="showPanel = false"
      >
      <svg class="profile" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M16.1599 15.2295H15.8399C14.9064 15.2295 14.011 14.8586 13.3509 14.1985C12.6908 13.5384 12.3199 12.643 12.3199 11.7095V10.4595C12.3186 9.99684 12.4087 9.53852 12.5852 9.11086C12.7616 8.6832 13.0208 8.29463 13.348 7.96751C13.6751 7.64038 14.0637 7.38115 14.4913 7.20472C14.919 7.02829 15.3773 6.93815 15.8399 6.93947H16.1599C16.6225 6.93815 17.0809 7.02829 17.5085 7.20472C17.9362 7.38115 18.3248 7.64038 18.6519 7.96751C18.979 8.29463 19.2382 8.6832 19.4147 9.11086C19.5911 9.53852 19.6812 9.99684 19.6799 10.4595V11.7095C19.6799 12.643 19.3091 13.5384 18.6489 14.1985C17.9888 14.8586 17.0935 15.2295 16.1599 15.2295ZM19.8299 17.1095C18.7657 17.8254 17.5125 18.2083 16.2299 18.2095H15.7699C14.4873 18.2083 13.2341 17.8254 12.1699 17.1095C11.0848 17.1877 10.0695 17.6734 9.3276 18.4691C8.5857 19.2648 8.17215 20.3116 8.16992 21.3995V24.2595H23.8399V21.3995C23.8377 20.3116 23.4241 19.2648 22.6822 18.4691C21.9404 17.6734 20.925 17.1877 19.8399 17.1095" fill="white"/>
        </svg>
        {{ userProfile.lastName }} {{ userProfile.firstName | initial }}
        <div
          class="user-dropdown"
          [hidden]="!showPanel"
          [class.white-bg]="whiteHeaderUserPanel"
        >
          <ul>
            <li>
              <a [routerLink]="['/user-profile']">
                <img
                  [src]= "'img/1734_Profile.svg'"
                      
               
                  alt="Profile"
                  class="profile_img"
                />
                User Profile
              </a>
            </li>
            <li class="purchase">
              <a [routerLink]="['/purchase-history']">
                <space-icon class="icon" icon="bankcard" outline="false">
                </space-icon>
                Purchase history
              </a>
            </li>
            <li>
              <a (click)="triggerLogout()">
                <img
                  [src]="'img/2115_Exit.svg'"
                  alt="Profile"
                  class="profile_img"
                />
                Logout
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <notification-toast></notification-toast>
  </div>
</header>
